<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
              v-model="listQuery.businessNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务名称</span>
            <el-input
                v-model="listQuery.businessName"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">业务型号</span>
            <el-input
                v-model="listQuery.businessModel"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">公司名称</span>
            <el-input
                v-model="listQuery.customerCompany"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">联系人</span>
            <el-input
                v-model="listQuery.customerCompanyContact"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">报价日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @keyup.enter="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @keyup.enter="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="el => { if (el) tableListRef[0] = el }"
              v-loading="listLoading"
              :dataList="list"
              :total="total"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :handleDefaultWidth="120"
              :permissionName="permissionName"
              :showSelection="true"
              :showSummary="true"
              :isShowPagination="false"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              style="height:100% ;overflow:hidden;"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:operation-action="scope">
                <el-link
                  v-permission="{ pkey: `${permissionName}_EDIT` }"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('edit', scope.row)"
                >
                    {{ t("table.edit") }}
                </el-link>
                <el-link
                  v-permission="{ pkey: `${permissionName}_PRINT` }"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('print', scope.row)"
                >
                  打印
                </el-link>
                <!-- <el-link
                  v-permission="{pkey:`${permissionName}_DELETE`}"
                  href="javascript:void(0);"
                  type="danger"
                  @click="handleCommand('delete',scope.row)"
                >
                    {{ t("table.delete") }}
                </el-link> -->
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li v-for="item in tabList" :key="item.id" :class="{ active: activeTab === item.id }" @click="handleTabClick(item)">{{item.name}}</li>
                </ul>
              </div>
              <!-- <TraceInfo v-if="activeTab===3" ref="TraceInfo" :id="activeId"/> -->
              <BusinessInfo v-if="activeTab === 2" ref="TraceInfo" :id="activeId" api="quotation"/>
        </div>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :dialogFormVisible="dialogFormVisible"
      :api="'quotation'"
      :handleResolveTempData="handleResolveTempData"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <el-button type="primary" circle @click="handleSubMenuCollapse" class="subMenuCollapseBtn" v-if="!dialogFormVisible"> {{isSubMenuCollapse ? '展开' : '收起'}}</el-button>
    <el-dialog
      v-if="printVisible"
      v-model="printVisible"
      title="打印预览"
      width="80%"
      append-to-body
    >
      <PrintCom ref="PrintCom" :id="activeRow.id" />
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="printVisible = false" type="danger">取消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { defineComponent, reactive, toRefs, onMounted, ref, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { deleteById, getPageList } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'

import { UsersModel } from '@/model/userModel'

import { getDropdownByType } from '@/apis/tool'
import { ArrayRowsItem } from '@/model/Index'

import FormComponent from './From.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import BusinessInfo from '@/views/order/businessInfo/Index.vue'

import { TableField } from './FieldTable'
import { defaultDate, pageVo, pageSizes } from '@/utils/index'
import mixin from '@/mixins/index'
import PrintCom from './print/Index.vue'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Quotation',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    BusinessInfo,
    PrintCom
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref([])

    const dataMap = reactive({
      TableName: TableName.TABLE_QUOTATION,
      permissionName: permissionName.QUOTATION,
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        brand: undefined,
        model: undefined,
        serial: undefined,
        type: undefined,
        urgentId: undefined,
        customerCompanyName: undefined,
        customerCompanyContactName: undefined,
        customerCompanyContactPhone: undefined,
        salesManId: undefined,
        engineerId: undefined,
        outsourceCompanyName: undefined,
        outsourceCompanyContactName: undefined,
        outsourceCompanyContactPhone: undefined,
        startTime: '',
        endTime: '',
        status: undefined,
        ...pageVo

      },
      dialogFormVisible: false,
      statusOption: [],
      urgentOption: [],
      businessTypeOption: [],
      engineerOption: [],
      salesManOption: [],
      pageSizes,
      tabList: [
        { name: '业务信息', id: 2 }
        // { name: '跟踪信息', id: 3 }
      ],
      newHpx: 0,
      activeTab: 2,
      printVisible: false,
      activeRow: null,

      handleCommand(command: string, val?: any) {
        console.log(command, 'command')
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'print':
            dataMap.activeRow = val
            dataMap.printVisible = true
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getPageList('quotation', dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          brand: undefined,
          model: undefined,
          serial: undefined,
          type: undefined,
          urgentId: undefined,
          customerCompanyName: undefined,
          customerCompanyContactName: undefined,
          customerCompanyContactPhone: undefined,
          salesManId: undefined,
          engineerId: undefined,
          outsourceCompanyName: undefined,
          outsourceCompanyContactName: undefined,
          outsourceCompanyContactPhone: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.dialogFormVisible = true
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('business', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleResolveTempData(tempModel: any) {
        const { model } = tempModel
        tempModel.model = model ? model.join(',') : ''
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/BusinessStatus').then((res: any) => {
          dataMap.statusOption = res || []
        })
        getUrlList('urgency/dropdown').then((res: any) => {
          dataMap.urgentOption = res || []
        })
        getUrlList('dropdown/BusinessType').then((res: any) => {
          dataMap.businessTypeOption = res || []
        })
      },
      handleEngineerFocus() {
        getUrlList('user/dropdown/engineers?all=true').then((res: any) => {
          dataMap.engineerOption = res || []
        })
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          } else if (column.selectType === 2 && column.url) {
            getUrlList(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      }

    })
    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./business/quotation',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })

    onMounted(() => {
      mixinData.initHeight()

      // dataMap.loadTableSelectOption()
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse, tableListRef }
  }
})
</script>
<style  lang="scss">

</style>
